import { toast } from 'sonner'
import Loading from '@/components/Loading'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { formatDateFR } from '@/lib/utils'
import {
  useSendTrialWinbackMutation,
  useTrialWinbackListQuery,
} from '@/hooks/usePlatformCampaigns'
import { SendTrialWinbackAllButton } from './ui/SendTrialWinbackAllButton'

export default function PlatformCampaignsPage() {
  const { data, isPending, error } = useTrialWinbackListQuery()
  const sendOne = useSendTrialWinbackMutation()

  if (isPending) return <Loading />
  if (error || !data?.ok)
    return (
      <div className='text-sm text-destructive'>
        Erreur chargement de la campagne
      </div>
    )

  const items = data.items

  const handleSend = async (ownerId: string, ownerName: string) => {
    try {
      await sendOne.mutateAsync(ownerId)
      toast.success('Email envoyé', { description: ownerName })
    } catch (e: unknown) {
      const description =
        (e as { response?: { data?: { message?: string } } })?.response?.data
          ?.message ?? 'Erreur inconnue'
      toast.error('Envoi impossible', { description })
    }
  }

  return (
    <Card>
      <CardHeader>
        <div className='flex items-start justify-between gap-3'>
          <div>
            <h2 className='text-xl font-semibold'>
              Campagnes — Relance essai
            </h2>
            <p className='text-sm text-muted-foreground'>
              Owners ayant testé MOGESAPP sans jamais s'abonner.
            </p>
          </div>

          <SendTrialWinbackAllButton
            pendingCount={items.filter((i) => !i.sentAt).length}
          />
        </div>
      </CardHeader>

      <CardContent>
        {items.length === 0 ? (
          <p className='text-sm text-muted-foreground'>
            Aucun owner éligible actuellement.
          </p>
        ) : (
          <div className='space-y-2'>
            {items.map((o) => (
              <div
                key={o.ownerId}
                className='flex flex-col gap-2 rounded-lg border p-3 md:flex-row md:items-center md:justify-between'
              >
                <div>
                  <div className='font-medium'>{o.ownerName}</div>
                  <div className='text-xs text-muted-foreground'>
                    {o.ownerEmail ?? '—'}
                  </div>
                  <div className='text-xs text-muted-foreground'>
                    Essai terminé le {formatDateFR(o.trialEndsAt)} (
                    {o.daysSinceTrialEnded} j)
                  </div>
                </div>

                {o.sentAt ? (
                  <Badge variant='secondary'>
                    Envoyé le {formatDateFR(o.sentAt)}
                  </Badge>
                ) : (
                  <Button
                    size='sm'
                    onClick={() => handleSend(o.ownerId, o.ownerName)}
                    disabled={sendOne.isPending}
                  >
                    Envoyer
                  </Button>
                )}
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  )
}
